<mat-card class="cardWithShadow" style="margin: 0; height: 100%;overflow: hidden;border-radius: 0;">
    <mat-card-header class="w-100 d-block p-0" style="background-color: #1e293b;border-bottom: 3px solid #5d87ff;">
        <mat-card-title>
            <div class="w-100 d-flex" style="background: #0f172a;">
                <span style="display: flex; align-items: center; margin-left: 15px; color: #1bbaee; font-size: 14px;">
                    {{ "Configuration Imprimante Standard" | translate }}
                </span>
                <button class="m-l-auto" mat-icon-button (click)="close();">
                    <i-tabler name="x" class="icon-18" style="color: #1bb3e6;"></i-tabler>
                </button>
            </div>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content style="flex: 1;padding: 10px; padding-top: 30px; display: flex; flex-direction: column; align-items: center">
        <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
        <form [formGroup]="stdPrinterConfigForm" (ngSubmit)="doSubmit()" style="width: 100%;">
            <mat-form-field appearance="outline" class="w-100" color="primary" [floatLabel]="'always'">
                <mat-label class="mat-subtitle-2 f-s-14 f-w-600">{{ "Imprimante Standard" | translate }}</mat-label>
                <input matInput formControlName="STD_PRINTER_ID" [readonly]="true" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100" color="primary" [floatLabel]="'always'">
                <mat-label class="mat-subtitle-2 f-s-14 f-w-600">{{ "Orientation Impression" | translate }}</mat-label>
                <mat-select formControlName="STD_PRINTER_ORIENTATION">
                    <mat-option [value]="orientation.mVALUE_MEMBER" *ngFor="let orientation of PRINT_ORIENTATION_OPTIONS">{{ orientation.mDISPLAY_MEMBER }}</mat-option>
                </mat-select>
            </mat-form-field>
        </form>
        <div class="error-container" style="width: 98%;margin-bottom: 10px;" *ngIf="!!error">{{ error }}</div>
    </mat-card-content>
    <mat-card-actions class="d-block m-0 p-0" style="background-color: #0f172a;border-top: 3px solid #5d87ff;">
        <div class="d-flex w-100" style="border-right: 3px solid #1855d5; margin-right: 15px;height: 100px;">
            <button mat-stroked-button style="color: #707387; font-weight: 700; border: 1px solid; margin-left: 10px; margin-right: 10px; flex: 1; margin-top: auto; margin-bottom: auto; height: 80px;" (click)="close();">
                {{ "FERMER" | translate }}
            </button>
            <button mat-stroked-button [disabled]="loading || stdPrinterConfigForm.invalid" (click)="doSubmit()" class="ccmainfo" style="color: #1bbaee; font-weight: 700; border: 1px solid; margin-left: 10px; margin-right: 10px; flex: 1; margin-top: auto; margin-bottom: auto; height: 80px;">
                {{ "VALIDER" | translate }}
            </button>
        </div>
    </mat-card-actions>
</mat-card>